<template>
  <div ref="divide-card-container" class="divide-card-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
  }">
    <div class="award-num" :style="{
      'background': `url(${cc.title_bg}) no-repeat center / 100% 100%`,
      'color': gc.text_color,
      'visibility': cd.hb_num ? '' : 'hidden'
      }">
      <div>{{cd.state == 2 || cd.state == 3 ? '恭喜你' : '预计可'}}分得</div>
      <div class="num">{{cd.hb_num}}</div>
      <div>H币</div>
    </div>
    <div class="header-desc" :style="{'color': hexToRgba(cc.tip_text_color || gc.main_color, .8)}">
      <template v-if="cd.state != 2">
        <!-- <span>已有</span>
        <span class="num" :style="{'color': gc.text_color, 'background-color': gc.main_color}">{{cd.total_get}}</span>
        <span>位盒友集齐，</span> -->
        <span class="num" :style="{'color': gc.text_color, 'background-color': gc.main_color}">{{formatDateByTemplet(cd.end_time)}}</span>
        <span>前，每次集齐即可合成一次奖励</span>
      </template>
      <template v-else>
        <span>{{cd.total_get}}位盒友参与瓜分，{{cd.open_time}}已开奖</span>
      </template>
    </div>
    <div class="cards-container">
      <div class="row" v-for="(row, index) in show_list" :key="index" :style="{'justify-content': index = row.length === 2 ? 'center' : ''}">
        <div @click="showDetail(item)" class="img-box" v-for="(item, index1) in row" :key="index1" ref="card" :style="{'margin-right': row.length == 2 && index1 == 0 ? '8px' : ''}">
          <img v-if="item.count == 0" class="front" :src="item.cover_url" alt="">
          <img v-else class="back" :src="item.small_card_url" alt="">
          <div class="num" v-if="item.count > 1" :style="{'color': gc.main_color, 'background-color': gc.text_color}">
            <span>x{{item.count}}</span>
          </div>
        </div>
      </div>
      <!-- <svg v-if="showLight" style="top: calc(50% + 4px)" class="light-svg" width="375" height="395" viewBox="0 0 375 395" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="light" fill-rule="evenodd" clip-rule="evenodd" d="M208.584 0L188.442 190.732L244.476 7.13254L283.291 23.6088L187.947 195.411L187.891 195.948L187.943 196.047L188.719 195.633L312.245 42.9379L342.062 72.755L192.952 193.38L362.398 103.178L378.194 142.275L189.293 196.34L188.873 196.681L188.841 196.786L189.682 197.043L385 176.416V218.584L194.267 198.442L377.867 254.476L361.391 293.291L189.588 197.948L188.918 197.878L189.366 198.719L342.062 322.245L312.245 352.062L191.618 202.948L281.822 372.398L242.725 388.194L188.659 199.292L188.321 198.873L188.213 198.841L187.957 199.682L208.584 395H166.416L186.557 204.267L130.524 387.867L91.7088 371.391L187.051 199.588L187.108 199.05L186.88 198.623L62.755 352.062L32.9379 322.245L186.126 198.32L186.158 198.213L185.368 197.972L13.6088 293.291L-2.86746 254.476L180.731 198.442L-10 218.584L-10 176.416L180.736 196.559L-2.86746 140.524L13.6088 101.709L185.368 197.027L185.938 196.853L185.633 196.28L32.9379 72.755L62.755 42.9379L183.38 192.048L93.1777 22.6021L132.275 6.80578L186.34 195.707L186.679 196.126L186.786 196.158L187.042 195.318L166.416 0H208.584Z" fill="url(#paint0_radial_204_9115)"/>
        <defs>
          <radialGradient id="paint0_radial_204_9115" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(187.5 197.5) rotate(90) scale(197.5)">
          <stop stop-color="#FFEBC7" stop-opacity="0.3"/>
          <stop offset="1" stop-color="#FFEBC7" stop-opacity="0"/>
          </radialGradient>
        </defs>
      </svg> -->
    </div>
    <div class="btn-done" @click="lottery" :style="{'background': `url(${cc.btn_bg || gc.btn_bg}) no-repeat center / 100% 100%`,'color': gc.text_color}">
      {{btn_desc}}
    </div>
    <div ref="card-modal" class="card-modal" v-if="card_index !== -1">
      <div class="img-box">
        <img :src="cd.card_list[card_index].small_card_url" alt="">
      </div>
    </div>
    <Modal2 ref="detail-modal" width="calc(100% - 108px)" :over_close="false">
      <div class="detail-modal">
        <div ref="detail-modal-title" class="title">
          恭喜抽到一张卡牌
        </div>
        <div ref="inner-box" class="inner" :class="class_name">
          <div class="img-box" ref="modal-img">
            <img class="front" :src="cc.big_back" alt="">
            <div class="back">
              <img ref="back-img" class="back-img" :src="modal_img" alt="">
              <img ref="modal-mask" class="mask" :src="cc.modal_back" alt="">
            </div>
          </div>
        </div>
        <div ref="detail-modal-btn"  class="btn" @click="closeDetailModal" :style="{
          'background': `url(${gc.modal_confirm_btn_big}) no-repeat center / 100% 100%`,
          'color': gc.text_color,
          }">开心收下</div>
      </div>
    </Modal2>
    <Modal2 ref="all-card-modal" width="calc(100% - 88px)" :over_close="false">
      <div class="all-card-modal">
        <p class="title">恭喜 你已集齐{{cd.card_list.length}}种卡牌</p>
        <p class="desc">{{modal_desc}}</p>
        <svg class="close-svg" @click="closeAllCardModal" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_87_3663)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1.31251C5.42589 1.31251 1.31251 5.42589 1.31251 10.5C1.31251 15.5741 5.42589 19.6875 10.5 19.6875C15.5741 19.6875 19.6875 15.5741 19.6875 10.5C19.6875 5.42589 15.5741 1.31251 10.5 1.31251ZM0.787506 10.5C0.787506 5.13594 5.13594 0.787506 10.5 0.787506C15.8641 0.787506 20.2125 5.13594 20.2125 10.5C20.2125 15.8641 15.8641 20.2125 10.5 20.2125C5.13594 20.2125 0.787506 15.8641 0.787506 10.5Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7587 7.24127C13.9638 7.4463 13.9638 7.77871 13.7587 7.98374L7.98374 13.7587C7.77871 13.9638 7.4463 13.9638 7.24127 13.7587C7.03625 13.5537 7.03625 13.2213 7.24127 13.0163L13.0163 7.24127C13.2213 7.03625 13.5537 7.03625 13.7587 7.24127Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.24127 7.24127C7.03625 7.4463 7.03625 7.77871 7.24127 7.98374L13.0163 13.7587C13.2213 13.9638 13.5537 13.9638 13.7587 13.7587C13.9638 13.5537 13.9638 13.2213 13.7587 13.0163L7.98374 7.24127C7.77871 7.03625 7.4463 7.03625 7.24127 7.24127Z" fill="white"/>
          </g>
          <defs>
          <clipPath id="clip0_87_3663">
          <rect width="21" height="21" fill="white"/>
          </clipPath>
          </defs>
        </svg>
        <div class="cards">
          <div class="row" v-for="(row, index) in show_list" :key="index" :style="{'justify-content': index = row.length === 2 ? 'center' : ''}">
            <div class="card" v-for="(item, index1) in row" :key="index1" :style="{'margin-right': row.length == 2 && index1 == 0 ? '16px' : ''}">
              <img class="back" :src="item.small_card_url" alt="">
            </div>
          </div>
          <!-- <svg class="light-svg" width="375" height="395" viewBox="0 0 375 395" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="light" fill-rule="evenodd" clip-rule="evenodd" d="M208.584 0L188.442 190.732L244.476 7.13254L283.291 23.6088L187.947 195.411L187.891 195.948L187.943 196.047L188.719 195.633L312.245 42.9379L342.062 72.755L192.952 193.38L362.398 103.178L378.194 142.275L189.293 196.34L188.873 196.681L188.841 196.786L189.682 197.043L385 176.416V218.584L194.267 198.442L377.867 254.476L361.391 293.291L189.588 197.948L188.918 197.878L189.366 198.719L342.062 322.245L312.245 352.062L191.618 202.948L281.822 372.398L242.725 388.194L188.659 199.292L188.321 198.873L188.213 198.841L187.957 199.682L208.584 395H166.416L186.557 204.267L130.524 387.867L91.7088 371.391L187.051 199.588L187.108 199.05L186.88 198.623L62.755 352.062L32.9379 322.245L186.126 198.32L186.158 198.213L185.368 197.972L13.6088 293.291L-2.86746 254.476L180.731 198.442L-10 218.584L-10 176.416L180.736 196.559L-2.86746 140.524L13.6088 101.709L185.368 197.027L185.938 196.853L185.633 196.28L32.9379 72.755L62.755 42.9379L183.38 192.048L93.1777 22.6021L132.275 6.80578L186.34 195.707L186.679 196.126L186.786 196.158L187.042 195.318L166.416 0H208.584Z" fill="url(#paint0_radial_204_9115)"/>
            <defs>
              <radialGradient id="paint0_radial_204_9115" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(187.5 197.5) rotate(90) scale(197.5)">
              <stop stop-color="#FFEBC7" stop-opacity="0.3"/>
              <stop offset="1" stop-color="#FFEBC7" stop-opacity="0"/>
              </radialGradient>
            </defs>
          </svg> -->
        </div>

        <svg v-if="award_type == 1" @click="closeAllCardModal" class="close" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5ZM1.5 20C1.5 9.78273 9.78273 1.5 20 1.5C30.2173 1.5 38.5 9.78273 38.5 20C38.5 30.2173 30.2173 38.5 20 38.5C9.78273 38.5 1.5 30.2173 1.5 20Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.2071 13.7929C26.5976 14.1834 26.5976 14.8166 26.2071 15.2071L15.2071 26.2071C14.8166 26.5976 14.1834 26.5976 13.7929 26.2071C13.4024 25.8166 13.4024 25.1834 13.7929 24.7929L24.7929 13.7929C25.1834 13.4024 25.8166 13.4024 26.2071 13.7929Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7929 13.7929C13.4024 14.1834 13.4024 14.8166 13.7929 15.2071L24.7929 26.2071C25.1834 26.5976 25.8166 26.5976 26.2071 26.2071C26.5976 25.8166 26.5976 25.1834 26.2071 24.7929L15.2071 13.7929C14.8166 13.4024 14.1834 13.4024 13.7929 13.7929Z" fill="white"/>
        </svg>
        <div v-else class="btn" @click="toLottery" :style="{
          'background': `url(${gc.modal_confirm_btn_big}) no-repeat center / 100% 100%`,
          'color': gc.text_color,
          }">去抽奖</div>
      </div>
    </Modal2>
    <Modal ref="success-modal" :width="299" :gc="gc" :cc="cc" title="恭喜获得">
      <div class="success-modal-wrapper modal-content">
        <div class="modal-item">
          <div class="image-box">
            <!-- <img :src="award.img_url" alt=""> -->
            <HBSvg :bg="gc.main_color"></HBSvg>
          </div>
          <p class="prize-name" :style="{'color': gc.main_color}">{{award.name}}</p>
        </div>
        <p class="distribute-desc" :style="{'color':  hexToRgba(gc.main_color, .8)}">{{award.notify_content}}</p>
        <div class="btn-done" @click="closeSuccessModal" :style="{'background': cc.modal_confirm_btn_big || gc.modal_confirm_btn_big ? `url(${cc.modal_confirm_btn_big || gc.modal_confirm_btn_big}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color,'margin-top': '10px'}">确认</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin'
import { utils } from '_lib/utils'
import { openSelectCard, combineCard } from '_api/activity-common-template'
import HBSvg from '../images/hb'

export default {
  name: 'fes-card-2021',
  components: { HBSvg },
  data () {
    return {
      card_index: -1,
      card_id: -1,
      pos: {},
      close_lock: false,
      modal_img: '',
      class_name: 'transition1',
      animate_temp: 0,
      timer: null,
      timer2: null,
      is_failed: false,
      award: {
        name: '',
        notify_content: '奖品将放入游戏库-黑盒商城-我的钱包'
      },
      is_select_all: false,
      modal_desc: '',
      award_type: 1 // 1h币，2开奖次数
    }
  },
  mixins: [ ComponentCommonMixin ],
  computed: {
    show_list () {
      const list = []
      const temp = utils.deepCopy(this.cd.card_list)
      while (temp.length > 0) {
        list.push(temp.splice(0, 3))
      }
      return list
    },
    btn_desc () {
      if (this.cd.left_combine_cnt) {
        return '立即合成'
      }
      return `抽卡（剩余次数${this.cd.left_box_cnt}）`
    },
    showLight () {
      return this.cd.card_list.filter(item => item.count > 0).length == this.cd.card_list.length
    }, 
  },
  mounted () {
    setTimeout(() => {
      utils.prefetchImage([...this.cd.card_list.map(item => item.big_card_url), this.cd])
    }, 100)
    this.getAnimateProperty()
  },
  methods: {
    lottery () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.lottery_lock) {
        return
      }
      // 合成
      if (this.cd.left_combine_cnt) {
        this.combineCard()
      } else if (this.cd.left_box_cnt) { // 抽卡
        this.openCard()
      }
    },
    combineCard () {
      combineCard({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.querys.act_id
      }).then(res => {
        if (res.data.status == 'ok') {
          const data = res.data.result
          this.modal_desc = data.notify_content
          this.award_type = data.award_type
          this.lottery_lock = false
          this.$set(this.cd, 'left_combine_cnt', 0)
          this.cd.card_list.forEach(item => {
            item.count--
          })
          this.showAllCardModal()
          this.$parent.reload()
        }
      })
    },
    openCard () {
      this.is_failed = false
      this.lottery_lock = true
      this.$refs['detail-modal'].showModal()
      this.showCardAnimate()
      openSelectCard({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id
      }).then(res => {
        if (res.data.status === 'ok') {
          // this.card_id = 1673861879729
          this.card_id = parseInt(res.data.result.card_id)
          const card_index = this.cd.card_list.findIndex(item => item.card_id == this.card_id)
          this.modal_img = this.cd.card_list[card_index].big_card_url
          this.lottery_lock = false
          this.$set(this.cd, 'left_box_cnt', this.cd.left_box_cnt - 1)
        } else {
          // 添加错误处理
          setTimeout(() => {
            this.is_failed = true
            this.hideDetailModal()
            utils.showMessage('failed', res.data.msg)
          }, 1500)
        }
      })
    },
    toLottery () {
      this.closeAllCardModal()
      setTimeout(() => {
        const lottery_dom = document.querySelector('.lottery-container')
        if (this.gc.bg_fixed) {
          utils.easeOutScrollTo(lottery_dom.offsetTop - 40, document.querySelector('#outer-content'))
        } else {
          utils.easeOutScrollTo(lottery_dom.offsetTop - 40)
        }
      }, 500)
    },
    showCardAnimate () {
      setTimeout(() => {
        this.$refs['inner-box'].setAttribute('style', `${this._transform}: translate3d(0,0,0) scale(1)`)
        this.$refs['modal-mask'].setAttribute('style', 'visibility: hidden')
      }, 50)
      setTimeout(() => {
        if (this.card_id === -1) {
          this.class_name = 'transition2'
        }
        this.$refs['inner-box'].setAttribute('style', `${this._transform}: translate3d(0,0,0) scale(1.06)`)
      }, 550)
      setTimeout(() => {
        if (this.card_id !== -1) {
          this.showFinalAnimate()
        } else {
          this.class_name = 'transition2'
          // 如果此时还没获取到结果，则等待，100ms查询一次，获取到了再出现动画
          this.timer = setInterval(() => {
            if (this.is_failed) {
              clearInterval(this.timer)
              clearInterval(this.timer2)
              return
            }
            if (this.card_id !== -1) {
              this.class_name = 'transition3'
              clearInterval(this.timer)
              clearInterval(this.timer2)
              if (this.animate_temp % 2 == 0) {
                this.$refs['inner-box'].setAttribute('style', `${this._transform}: translate3d(0,0,0) scale(1.06);`)
                setTimeout(() => {
                  this.showFinalAnimate()
                }, 500)
              } else {
                this.showFinalAnimate()
              }
            } else {
              if (!this.timer2) {
                this.$refs['inner-box'].setAttribute('style', `${this._transform}: translate3d(0,0,0) scale(${[1, 1.06][this.animate_temp % 2]});`)
                this.timer2 = setInterval(() => {
                  this.animate_temp ++
                  this.$refs['inner-box'].setAttribute('style', `${this._transform}: translate3d(0,0,0) scale(${[1, 1.06][this.animate_temp % 2]});`)
                }, 750)
              }
            }
          }, 100)
        }
      }, 1250)
    },
    // 翻转+最终动画
    showFinalAnimate () {
      this.class_name = 'transition1'
      this.$refs['modal-img'].setAttribute('style', `${this._transform}: rotateY(-180deg);`)
      setTimeout(() => {
        this.$refs['modal-mask'].setAttribute('style', 'visibility: unset;')
      }, 210)
      setTimeout(() => {
        this.$refs['inner-box'].setAttribute('style', `${this._transform}: translate3d(0,0,0) scale(1);`)
        setTimeout(() => {
          this.$refs['detail-modal-btn'].style[this._transform] = 'scale(1)'
        }, 500)
        this.$refs['detail-modal-title'].setAttribute('style', `opacity: 1; ${this._transform}: translateY(0)`)
        this.$refs['back-img'].setAttribute('style', 'visibility: unset')
        this.$refs['modal-mask'].setAttribute('style', 'visibility: unset; animation: fadeOut .5s cubic-bezier(.42, 0, .58, 1)')
        setTimeout(() => {
          this.$refs['modal-mask'].setAttribute('style', 'visibility: hidden')
        }, 500)
      }, 500)
    },
    closeDetailModal () {
      if (this.close_lock) {
        return
      }
      this.close_lock = true
      this.card_index = this.cd.card_list.findIndex(item => item.card_id == this.card_id)
      this.hideDetailModal()
      const posInfo = this.$refs['card'][this.card_index].getBoundingClientRect()
      this.pos.left = (posInfo.left / window.innerWidth) * 100 + '%'
      this.pos.top = (posInfo.top / window.innerHeight) * 100 + '%'
      setTimeout(() => {
        this.pos.scale = (posInfo.width / this.$refs['card-modal'].getBoundingClientRect().width)
      }, 0)
      setTimeout(() => {
        this.$refs['card-modal'].setAttribute('style', `left: ${this.pos.left}; top: ${this.pos.top}; ${this._transform}: scale(${this.pos.scale}) translate3d(0, 0, 0);`)
      }, 50)
      setTimeout(() => {
        const temp = this.cd.card_list[this.card_index]
        temp.count ++
        this.$set(this.cd.card_list, this.card_index, temp)
        this.card_id = -1
        this.card_index = -1
        this.close_lock = false
        this.animate_temp = 0
        this.timer = null
        this.timer2 = null
      }, 300)
      setTimeout(() => {
        if (this.cd.card_list.filter(item => item.count > 0).length === this.cd.card_list.length) {
          this.is_select_all = true
          this.$set(this.cd, 'left_combine_cnt', 1)
        }
      }, 350)
    },
    getAnimateProperty () {
      var el = document.createElement('p')
      var transitions = ['transition', 'oTransition', 'msTransition', 'mozTransition', 'webkitTransition']
      var transforms = ['transform', 'oTransform', 'msTransform', 'mozTransform', 'webkitTransform']
      for (let key in transitions) {
        if (transitions[key] in el.style) {
          // this._transition = transitions[key]
          this._transform = transforms[key]
          break;
        }
      }
    },
    hideDetailModal () {
      this.$nextTick(() => {
        this.card_id = -1
        this.$refs['detail-modal'].hideModal(true)
      })
    },
    showDetail (item) {
      if (this.cd.card_list.find(card => card.card_id == item.card_id).count > 0) {
        this.openImage([{src: item.big_card_url}], 1)
      }
    },
    showAllCardModal () {
      this.$refs['all-card-modal'].showModal(true)
    },
    closeAllCardModal () {
      this.$refs['all-card-modal'].hideModal(true)
    },
    showSuccessModal () {
      this.$refs['success-modal'].showModal()
    },
    closeSuccessModal () {
      this.$refs['success-modal'].hideModal()
    },
    openImage (imgs, index) {
      window.location.href = this.openImg({
        imgs: imgs,
        index: index
      })
    },
    openImg (imgInfo) {
      var imgsUrlsString = null;
      if (!imgsUrlsString) {
        var imgsUrls = [];
        var eImgs = imgInfo.imgs;
        for (var i = 0; i < eImgs.length; i++) {
          imgsUrls.push(eImgs[i].src)
        }
        imgsUrlsString = imgsUrls.join(';')
      }
      return 'maxjia:///showPictureDetail#/' + imgInfo.index + '#/' + imgsUrlsString
    },
  }
}
</script>

<style lang="less">
.divide-card-container {
  margin: 32px 14px;
  position: relative;
  .transition1 {
    transition: transform .5s cubic-bezier(.7, -.4, .4, 1.4);
  }
  .transition2 {
    transition: transform .75s cubic-bezier(.42, 0, .58, 1);
  }
  .transition3 {
    transition: transform .5s cubic-bezier(.42, 0, .58, 1);
  }
  .award-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
    z-index: 1;
    width: 199px;
    height: 27px;
    div {
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      position: relative;
      top: 1px;
      white-space: nowrap;
      &.num {
        font-family: ALIBABA Font;
        font-size: 20px;
        line-height: 24px;
        margin: 0 4px;
        top: -2px;
      }
    }
  }
  .header-desc {
    margin: 0 auto 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    position: relative;
    span {
      font-size: 13px;
      line-height: 18px;
      z-index: 2;
    }
    .num {
      margin: 0 3px;
      padding: 0 2px;
      font-weight: 600;
      border-radius: 2px;
      height: 16px;
      line-height: 18px;
      z-index: 2;
    }
  }
  .cards-container {
    margin: 0 26px 20px;
    z-index: 1;
    position: relative;
    .row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      z-index: 2;
    }
    .img-box {
      width: calc((100% - 16px) / 3);
      position: relative;
      height: 0;
      padding-bottom: 41.02%;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      .num {
        position: absolute;
        padding: 1px 4px;
        top: -2px;
        right: -2px;
        border-radius: 8.69405px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-weight: 600;
          font-size: 10px;
          line-height: 12px;
          transform: matrix(1, 0, -0.09, 1, 0, 0);
        }
      }
    }
  }
  .btn-done {
    height: 44px;
    text-align: center;
    line-height: 44px;
    position: relative;
    z-index: 2;
    font-weight: 500;
  }
  .all-card-modal {
    background-color: transparent;
    position: relative;
    text-align: center;
    max-width: 480px;
    margin: 0 auto;
    .close-svg {
      position: absolute;
      top: 3px;
      right: 0;
    }
    .title {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #FFFFFF;
      z-index: 2;
    }
    .desc {
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      color: #FFD18B;
      margin: 10px auto 26px;
      z-index: 2;
    }
    .cards {
      margin-bottom: 54px;
      position: relative;
      z-index: 2;
      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .card {
          width: calc((100% - 16px) / 3);
          position: relative;
          height: 0;
          padding-bottom: 41.02%;
          z-index: 2;
          img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
          }
        }
      }
    }
    .btn {
      font-weight: 500;
      font-size: 15px;
      line-height: 36px;
      color: #C34F36;
      min-height: 36px;
      margin-top: -25px;
    }
  }
  .detail-modal {
    background-color: transparent;
    position: relative;
    text-align: center;
    max-width: 480px;
    margin: 0 auto;
    bottom: 50px;
    .title { 
      margin: 0 auto;
      position: relative;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #FFFFFF;
      transition: all .5s cubic-bezier(.42, 0, .58, 1);
      opacity: 0;
      transform: translateY(20px);
    }
    .inner {
      margin: 12px auto 14px;
      transform: translate3d(0,0,0) scale(0);
      // transition: transform .5s cubic-bezier(.7, -.4, .4, 1.4);
      .img-box {
        width: 100%;
        height: 0;
        padding-bottom: 132.941%;
        position: relative;
        perspective: 1000px;
        transform-style: preserve-3d;
        transition: transform .5s cubic-bezier(.42, 0, .58, 1);
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          backface-visibility:hidden
        }
        .back {
          position: absolute;
          transform: rotateY(180deg);
          width: 100%;
          height: 100%;
          .back-img {
            z-index: 2;
            visibility: hidden;
          }
          .mask {
            z-index: 5;
            transform: scale(375 / 276, 455 / 351);
            transform-origin: center;
          }
        }
      }
      .desc {
        font-size: 13px;
        line-height: 22px;
        text-align: center;
        color: #C34F36;
        animation: bounceIn 1s cubic-bezier(.7, -.4, .4, 1.4);
        &:nth-child(1) {
          margin-bottom: 4px;
        }
      }
    }
    .btn {
      font-weight: 500;
      font-size: 15px;
      line-height: 36px;
      color: #C34F36;
      min-height: 36px;
      transform: scale(0);
      transition: transform .3s cubic-bezier(.45, 1.45, .8, 1);
      // visibility: hidden;
      // animation: fadeIn .35s ease;
    }
  }
  .card-modal {
    position: fixed;
    top: calc(50% - 50px);
    left: calc(50% + 1px);
    width: 68vw;
    // animation: bounceOut 4s ease;
    transform-origin: left top;
    transform: translate3d(-50%, -50%, 0);
    transition: all .3s cubic-bezier(.42, 0, .58, 1);
    z-index: 20;
    .img-box {
      width: 100%;
      height: 0;
      padding-bottom: 132.941%;
      margin-bottom: 24px;
      img {
        width: 100%;
      }
    }
  }
  .light-svg {
    width: calc(100vw + 20px);
    height: calc(100vw + 20px);
    position: absolute;
    top: calc(50% - 37px);
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .light {
    animation: light 8s linear infinite;
    transform-origin: center;
    @keyframes light {
      to {
        transform: rotate(1turn);
      }
    }
  }
  .success-modal-wrapper {
    .modal-item {
      .image-box {
        position: relative;
        overflow: hidden;
        margin: 14px auto;
        text-align: center;
      }
      .prize-name {
        font-size: 13px;
        line-height: 16px;
        max-width: 100%;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  @keyframes bounceIn {
    0% {
      transform: translate3d(0, 0, 0) scale(0);
    }
    100% {
      transform: translate3d(0, 0, 0) scale(1);
    }
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes titleFade {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
